<template>
  <v-container fluid class="theme-color" style="height: auto;">
    <v-row class="card mt-4" justify-space-between>
      <v-col cols="12">
        <Search @getSummary="getSummary" @getSearchCondition="updateCondition" />
      </v-col>
      <!-- <v-col :class="[$vuetify.breakpoint.mdAndUp ? 'col-3' : 'col-12 mt-4']">
        <Today />
      </v-col>-->
    </v-row>

    <v-row class="card mt-4" v-show="!(condition && condition.isBMTA)">
      <v-col cols="12">
        <Cause :summary="summary" :searchCondition="condition" />
      </v-col>
    </v-row>

    <v-row class="card mt-4" v-show="!(condition && condition.isBMTA)">
      <v-col cols="12">
        <Area :searchCondition="condition" />
      </v-col>
    </v-row>

    <v-row 
      class="card mt-4" 
      v-show="condition && condition.isBMTA && !condition.vehicle && showDLT"
    >
      <v-col cols="12">
        <DLTType @getSummaryDLT="getSummaryDLT" :searchCondition="condition" @showDLT="setDLT" />
      </v-col>
    </v-row>

    <v-row 
      class="card mt-4" 
      v-show="condition && condition.isBMTA && !condition.vehicle && showBus"
    >
      <v-col cols="12">
        <Bus :searchCondition="condition" :summaryDLT="summaryDLT" @showBus="setBus" />
      </v-col>
    </v-row>

    <v-row 
      class="card mt-4" 
      v-show="condition && condition.isBMTA && !condition.vehicle && showTruck"
    >
      <v-col cols="12">
        <Truck :searchCondition="condition" :summaryDLT="summaryDLT" @showTruck="setTruck" />
      </v-col>
    </v-row>

    <v-row class="card mt-4">
      <v-col cols="12">
        <DayAndTime :searchCondition="condition" />
      </v-col>
    </v-row>

    <v-row class="card mt-4">
      <v-col cols="12">
        <ProvinceChart :searchCondition="condition" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Search from '../components/dashboard-road/Search.vue';
import Cause from '../components/dashboard-road/Cause.vue';
import Area from '../components/dashboard-road/Area.vue';
import DayAndTime from '../components/dashboard-road/DayAndTime.vue';
import DLTType from '../components/dashboard-road/DLTType.vue';
import Bus from '../components/dashboard-road/Bus.vue';
import Truck from '../components/dashboard-road/Truck.vue';
import ProvinceChart from '../components/dashboard-road/ProvinceChart.vue';

export default {
  name: 'DashboardRoad',
  components: {
    Search,
    Cause,
    Area,
    DayAndTime,
    DLTType,
    Bus,
    Truck,
    ProvinceChart
  },
  data: () => ({
    condition: null,
    summary: null,
    summaryDLT: null,
    showDLT: true,
    showBus: true,
    showTruck: true
  }),
  mounted() {
    this.$emit('sethambergervisible', false);
  },
  methods: {
    updateCondition(value) {
      this.condition = value;
    },
    getSummary(val) {
      this.summary = val;
    },
    getSummaryDLT(val) {
      this.summaryDLT = val;
    },
    setDLT(val) {
      this.showDLT = val;
    },
    setBus(val) {
      this.showBus = val;
    },
    setTruck(val) {
      this.showTruck = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  width: 85% !important;
  background: none;
  margin: auto;
}

.col {
  padding-top: 0;
  padding-bottom: 0;
}
</style>
